module.exports = __webpack_public_path__ + "media/images/drbill-11ffa8d6a52e6bd69d296d1abcaec238.jpg";